export default __webpack_public_path__ + "static/media/cake.a8c2db72.svg";